export default __webpack_public_path__ + "static/media/spaceman.8d1ee5d8.png";